import styled from "@emotion/styled";
import { Flex, mediaQueries, Theme } from "@ugc-ui/lego";
import { mixins } from "@src/styles/mixins.styled";

export const EditCampaignContainer = styled(Flex)<{ theme: Theme }>`
  overflow: auto;
  height: 670px;
  padding: 4px 10px 0 0;
  ${({ theme }) => mixins.scroll(theme)}
  ${mediaQueries.lg} {
    height: auto;
  }
`;
